import { useAppSelector } from '@verantos-dev/app-state-base';

import { selectActiveCohortBuilderItemCountFilter } from '../selectors/cohortBuilderEditModalSelectors';

export const useCountFilter = () => {
  const countFilter = useAppSelector(selectActiveCohortBuilderItemCountFilter);

  return {
    countFilter,
  };
};
